<oo-nav-back url="../../forms"></oo-nav-back>
<oo-loading-container [status]="state.status">
  <ng-template>
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>{{ state.areBettingsSet ? 'Betting Result' : 'Users Betting' }}</mat-card-title>
        <mat-card-subtitle>{{ state.form.name }}</mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        @if (state.form.bettingResult) {
          @for (betting of $any(state.form!.bettingResult)! | keyvalue; track betting) {
            <div class="oo-result-row">
              <div class="oo-betting-name">{{ keyToText($any(betting.key)) }}:</div>
              <oo-bet-result-renderer [bettingType]="$any(betting.key)"
                                      [bettingValue]="$any(betting.value)"
                                      [form]="state.form"
                                      [metadata]="state.metadata">
              </oo-bet-result-renderer>
            </div>
          }
        } @else {
          <div class="oo-no-results">
            Results are not set yet
          </div>
        }
      </mat-card-content>
      <mat-card-actions align="end">
          <div class="oo-resutls-actions-buttons">
            @if (state.simulatedResults) {
              <button mat-stroked-button (click)="clearSimulatedResults()">
                Clear Simulated Results
              </button>
            }
            <button mat-stroked-button color="primary" (click)="startResultsSimulationFlow()">
              {{ state.simulatedResults ? 'Update Simulated Results' : 'Simulate Results' }}
            </button>
          </div>
      </mat-card-actions>
    </mat-card>

    <mat-tab-group>
      <mat-tab label="User Betting">
        <mat-accordion>
          @for (userBetting of state.userBettingResults; track userBetting) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span>{{ userBetting.firstName }} {{ userBetting.lastName }}</span>
                  <span class="oo-user-score">({{ userBetting.score }})</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-list>
                @if (!userBetting.betting) {
                  <mat-list-item class="oo-bettings-list">
                    <mat-icon matListItemIcon>error</mat-icon>
                    <span matListItemTitle>No Bettings</span>
                  </mat-list-item>
                }
                @if (userBetting.betting) {
                  @for (betting of $any(userBetting.betting) | keyvalue; track betting) {
                    <mat-list-item class="oo-bettings-list">
                      @if (userBetting.bettingResults) {
                        <mat-icon matListItemIcon>
                          {{ userBetting.bettingResults[$any(betting.key)] === 'correct' ? 'done' : 'clear' }}
                        </mat-icon>
                      }
                      <div matListItemTitle>{{ keyToText($any(betting.key)) }}</div>
                      <oo-bet-result-renderer [bettingType]="$any(betting.key)"
                                              [bettingValue]="$any($any(userBetting.betting)[$any(betting.key)])"
                                              [form]="state.form"
                                              [metadata]="state.metadata"
                                              matListItemLine>
                      </oo-bet-result-renderer>
                    </mat-list-item>
                  }
                }
              </mat-list>
            </mat-expansion-panel>
          }
        </mat-accordion>
      </mat-tab>
      <mat-tab label="Betting Stats">
        <oo-bet-statistics [form]="state.form" [metadata]="state.metadata"
                           [usersBetting]="state.userBettingResults">
        </oo-bet-statistics>
      </mat-tab>
    </mat-tab-group>

  </ng-template>
</oo-loading-container>
